function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }
    return btoa(binary);
}
export function base64urlEncode(buffer) {
    return arrayBufferToBase64(buffer)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");
}
export async function sha256Hex(data) {
    const bytes = typeof data === "string"
        ? new TextEncoder().encode(data)
        : new Uint8Array(data);
    const hash = await crypto.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(hash))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}
export async function generateEd25519KeyPair() {
    return crypto.subtle.generateKey({ name: "Ed25519" }, true, ["sign", "verify"]);
}
export async function exportPublicKeyPem(publicKey) {
    const spki = await crypto.subtle.exportKey("spki", publicKey);
    const b64 = arrayBufferToBase64(spki);
    const lines = b64.match(/.{1,64}/g) ?? [b64];
    return `-----BEGIN PUBLIC KEY-----\n${lines.join("\n")}\n-----END PUBLIC KEY-----`;
}
export async function exportPrivateKeyJwk(privateKey) {
    return crypto.subtle.exportKey("jwk", privateKey);
}
export async function importPrivateKey(jwk) {
    return crypto.subtle.importKey("jwk", jwk, { name: "Ed25519" }, false, ["sign"]);
}
export async function buildCanonicalString(method, path, body, timestamp) {
    const bodyHash = await sha256Hex(body);
    return `${timestamp}\n${method.toUpperCase()}\n${path}\n${bodyHash}`;
}
export async function signCanonical(privateKey, canonical) {
    const signature = await crypto.subtle.sign("Ed25519", privateKey, new TextEncoder().encode(canonical));
    return base64urlEncode(signature);
}
export function buildAuthHeader(deviceId, timestamp, signature) {
    return `Device device_id="${deviceId}",timestamp="${timestamp}",signature="${signature}"`;
}
